/** Anchor ids used by service cards (#event-photo, …) → Gallery tab ids */
export const GALLERY_HASH_TO_TAB = {
  "event-photo": "event",
  "landscape-photo": "landscape",
  "action-photo": "action",
};

export const GALLERY_TAB_NAV_EVENT = "solitary-gallery-tab";
